import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export async function createCheckoutSession({ origin_url, email }) {
  const res = await axios.post(`${API}/checkout/session`, {
    product_id: "workbook",
    origin_url,
    email,
  });
  return res.data;
}

export async function getCheckoutStatus(sessionId) {
  const res = await axios.get(`${API}/checkout/status/${sessionId}`);
  return res.data;
}

export async function submitQuiz(payload) {
  const res = await axios.post(`${API}/quiz/submit`, payload);
  return res.data;
}
